<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 501 501"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M250.5 501C388.936 501 501 388.936 501 250.5C501 112.064 388.936 0 250.5 0C112.064 0 0 112.064 0 250.5C0 388.936 112.064 501 250.5 501ZM250.5 120C179.174 120 121 178.174 121 249.5C121 289.374 139.177 325.04 167.75 348.75L167.75 430L249.25 381.5C249.666 381.5 250.082 381.5 250.5 381.5C321.826 381.5 380 323.326 380 252C380 180.674 321.826 120 250.5 120Z"
      fill="#5B1CFF"
    />
  </svg>
</template>
